import { Card, CardContent, Typography } from "@mui/material";
import { BarChart, BarSeries } from "@mui/x-charts/BarChart";
import React, { useEffect, useMemo, useState } from "react";
import Spinner from "../../../common/components/Spinner";
import { useErrorHandler } from "../../../common/hooks";
import { BarChartModel } from "../../Models/Dashboards/BarChartModel";
import IComponentProps from "../IComponentProps";
import getComponentLayout from "../Table/getComponentLayout";

const BarChartComponent: React.FC<IComponentProps<BarChartModel>> = ({ component, context }) => {
  const errorHandler = useErrorHandler();

  const [data, setData] = useState<any>(null);
  const [dataPending, setDataPending] = useState<boolean>(false);

  const handleLoadData = async () => {
    if (!component.GetData) {
      console.warn("GetData expression is not defined.");
      return;
    }

    setDataPending(true);
    try {
      const result = await context.Evaluator.evaluate(component.GetData, context);
      setData(result);
    } catch (error) {
      errorHandler(error);
    } finally {
      setDataPending(false);
    }
  };

  useEffect(() => {
    handleLoadData();
  }, [component.GetData]);

  const chartData = useMemo(() => {
    if (!data) return { series: [], xAxis: [] };

    const series1: BarSeries = {
      data: component.Properties.map((prop) => (prop.Field ? parseFloat(data[prop.Field]) || 0 : 0)),
      id: "series-1",
    };

    const xAxis1 = {
      data: component.Properties.map((prop) => prop.Label),
      id: "x-axis-1",
    };
    return { series: [series1], xAxis: [xAxis1] };
  }, [data, component.Properties]);

  const componentLayoutSx = getComponentLayout(component);

  return (
    <Card sx={componentLayoutSx}>
      <CardContent sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        {component.HeaderLabel && (
          <Typography variant="h6" gutterBottom>
            {component.HeaderLabel}
          </Typography>
        )}
        {dataPending ? <Spinner /> : <BarChart series={chartData.series} xAxis={chartData.xAxis} layout="vertical" margin={0} />}
      </CardContent>
    </Card>
  );
};

export default BarChartComponent;
